export function replacePlaceholders(
  linkUrl: string,
  locale = 'en',
  country = 'US',
  dp = 'wildgames',
): string {
  //@TODO use real country and locale
  const placeholderMap = {
    '{#Brand}': dp,
    '{#Brand#}': dp,
    '{#Locale}': locale,
    '{#Locale#}': locale,
    '{#Country}': country,
    '{#Country#}': country,
    '{#DP}': dp,
    '{#DP#}': dp,
  };

  let result = linkUrl;
  for (const [placeholder, value] of Object.entries(placeholderMap)) {
    const regex = new RegExp(escapeRegex(placeholder), 'gi');
    result = result.replace(regex, value);
  }
  return result;
}

function escapeRegex(str: string): string {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
